<template>
    <div>
        <el-row class="padding10">
            <el-col :span="24" class="align-left padding5 padding-none-v">
                <slot name="area1"></slot>
                <label style="line-height: 35px" class="hidden-md-and-down">{{ T(`instrument_inventory.fact_equipment_nurse`) }}:</label>
                <label style="line-height: 35px" class="hidden-lg-and-up">器械:</label>
                <item-input
                    style="width: 220px"
                    class="hidden-md-and-down"
                    type="remotemultiselect"
                    v-model="equipments"
                    :options="workoption"
                    placeholder="护士签名"
                    :collapseTags="equipments.length > 2"
                ></item-input>
                <item-input
                    style="width: 130px"
                    class="hidden-lg-and-up"
                    type="remotemultiselect"
                    v-model="equipments"
                    :options="workoption"
                    placeholder="器械护士签名"
                    :collapseTags="true"
                ></item-input>
                <label style="line-height: 35px" class="hidden-md-and-down">&nbsp;巡回护士:</label>
                <label style="line-height: 35px" class="hidden-lg-and-up">&nbsp;巡回:</label>
                <item-input
                    style="width: 220px"
                    class="hidden-md-and-down"
                    type="remotemultiselect"
                    v-model="circuits"
                    :options="workoption"
                    placeholder="巡回护士签名"
                    :collapseTags="circuits.length > 2"
                ></item-input>
                <item-input
                    style="width: 130px"
                    class="hidden-lg-and-up"
                    type="remotemultiselect"
                    v-model="circuits"
                    :options="workoption"
                    placeholder="巡回护士签名"
                    :collapseTags="true"
                ></item-input>
                <el-button
                    v-if="rowChanges.length > 0 || equipments.toString() !== equipments_bak.toString() || circuits.toString() !== circuits_bak.toString()"
                    type="warning"
                    size="mini"
                    @click="SaveChanges"
                    ><i class="el-icon-loading" v-if="!finished"></i>保存</el-button
                >
                <el-link
                    v-if="rowChanges.length > 0 || equipments.toString() !== equipments_bak.toString() || circuits.toString() !== circuits_bak.toString()"
                    type="warning"
                    size="mini"
                    @click="clearChanges"
                >
                    撤销
                </el-link>
                <el-button type="primary" size="mini" @click="loadDamagedView">损耗记录</el-button>
            </el-col>
            <!-- <slot name="area2"></slot> -->
        </el-row>
        <el-table ref="cus-table" class="el-table--scrollable-y" :data="tableData" :span-method="objectSpanMethod" border :row-key="catKeyVal">
            <el-table-column width="100" v-if="package_style == 'separated'" prop="group_name" label="分组" header-align="center"> </el-table-column>
            <el-table-column prop="item_name" label="项目名称" header-align="center"> </el-table-column>
            <el-table-column :prop="item.prop" v-for="item in columnSetting" :key="item.prop + (item.locked ? '_1' : '_0')" :width="columnWidth" header-align="center">
                <span slot="header">
                    <span>{{ item.stage_name }}</span>
                    <span>
                        <span class="iconfont el-icon-plus fg-primary cus-button" v-if="!item.allow_edit" @click="loadAppendPackageView(item.id)" title="添加器械"></span>
                        <span class="el-icon-refresh-right fg-primary cus-button" v-else @click="AutoComplete(item.id)"></span>
                    </span>
                </span>
                <template slot-scope="scope">
                    <!-- {{scope.row[item.prop]}} -->
                    <span v-if="item.locked"></span>
                    <item-input
                        class="inventory-datetime"
                        v-else-if="scope.$index == 0 && (!showCountStageTime || showCountStageTime == `1`)"
                        type="hhdatetime"
                        v-model="scope.row[item.prop]"
                        datetimeFormate="yyyy/MM/dd HH:mm:ss"
                        showFormate="MM-dd HH:mm"
                        @input="RowChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                    >
                    </item-input>
                    <span v-else-if="scope.row[item.prop] == '-1'"></span>
                    <el-row v-else>
                        <el-col :span="14">
                            <item-input
                                v-if="item.allow_edit || isedit"
                                type="integer"
                                v-model="scope.row[item.prop]"
                                @activeRow="setActiveRow(arguments)"
                                :class="{ 'un-eq': scope.row[`un_eq_${item.prop}`] != scope.row[item.prop] }"
                                :readonly="(!checkboxs[scope.$index] && item.need_check && item.prop == checkColumn) || (item.prop != checkColumn && !isedit)"
                                @input="RowChange({ index: scope.$index, row: scope.row, prop: item.prop, column: item })"
                            ></item-input>
                            <span v-else>{{ scope.row[item.prop] }}</span>
                        </el-col>
                        <el-col :span="4" class="padding5">
                            <item-input type="checkbox" v-model="checkboxs[scope.$index]" v-if="item.prop == checkColumn"></item-input>
                        </el-col>
                        <el-col :span="6">
                            <span v-if="scope.row[`damaged_${item.prop}`]" class="cus-button is-circle bg-danger" style="float: right; width: 24px">
                                <el-popover
                                    placement="top-start"
                                    :title="scope.row[`damaged_${item.prop}`].stuff_destination"
                                    width="200"
                                    trigger="hover"
                                    :content="scope.row[`damaged_${item.prop}`].remark"
                                >
                                    <span slot="reference">{{ scope.row[`damaged_${item.prop}`].amount }} </span>
                                </el-popover>
                            </span>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>
        <!-- 添加器械包 -->
        <el-dialog class="form-table-h380" title="添加器械包" :visible.sync="packageIn.dialogFormVisible" :close-on-click-modal="false" width="80%">
            <cus-form
                ref="form-appendPackage"
                :data="packageIn"
                :columns="appendPackageColumns"
                @extrabutton-click="ExtraButtonClick2"
                @confirm="appendPackage"
                @new-scan="inStoreByScan"
                @addnew-scan="addAndInStoreByScan"
            ></cus-form>
        </el-dialog>
        <!-- 破损记录 -->
        <el-dialog class="form-table-h380" title="破损记录" :visible.sync="damagedView.dialogFormVisible" :close-on-click-modal="false" width="95%">
            <cus-form ref="form-damaged" :data="damagedView" :columns="damagedViewColumns" @extrabutton-click="ExtraButtonClick"></cus-form>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
const TIME_ROW_ID = `_m_t1`
export default {
    name: `ItemInstrument`,
    props: {
        id: { type: String | Number },
        workflow_name: { type: String },
        dic_worker_circuit: { type: Array },
        dic_worker_inst: { type: Array },
        enum_count_type: { type: String | Number },
        biz_surgery_info_id: { type: String | Number }
    },
    inject: [`reload`],
    data() {
        return {
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            mode: undefined,
            modes: [],
            columnSetting: [],
            tableData: [],
            instrument_count: 0, // 器械种类数  用于显示合并行
            supplies_count: 0, // 耗材种类数
            rowChanges: [],
            tableData_bak: [],
            surgeryId: this.biz_surgery_info_id,
            instruments_count_by_group: {},
            enum_package: [],
            instore_style: `hand`,
            packageWithBarcode: 1,
            package_style: this.$root[`PackageCountingType`], // separated  combin
            finished: true,
            equipments: this.dic_worker_inst || [],
            equipments_bak: this.dic_worker_inst || [],
            circuits: this.dic_worker_circuit || [],
            circuits_bak: this.dic_worker_circuit || [],
            checkColumn: undefined,
            checkboxs: [],
            stage: 0,
            packageIn: {
                dialogFormVisible: false,
                package_id: undefined,
                packages: [],
                activePackage: undefined,
                package_detail_quantity_label: `数量(总计：0个)`,
                instruments: [],
                enum_package: []
            },
            suppliesIn: {
                dialogFormVisible: false,
                supplies: []
            },
            damagedView: {
                dialogFormVisible: false,
                damaged: []
            },
            surgeryinfo: {},
            internalcodes: [],
            showCountStageTime: this.$root.ShowCountStageTime
        }
    },
    created() {
        this.$nextTick(function() {
            this.setTableheight()
        })
    },
    mounted() {
        if (this.surgeryId) {
            this.loadColumnSetting().then(() => {
                this.loadCountings()
            })
        }
        this.loadPackageWithBarcode()
        this.loadInternalcodes()
    },
    computed: {
        ...mapGetters([`permissions`, `sysuser/workers_by_duty`, `sysuser/workers_by_dutyNew`, `screenHeight`, `screenWidth`, `sys_enums`, `active_ward`, `userConfigs`]),
        tableHeight() {
            return this.screenHeight - 210
        },
        isedit() {
            return this.permissions && this.permissions.findIndex(item => item.no === `inventory_edit`) != -1
        },
        selectType() {
            let that = this
            let selectBy = _.filter(that.userConfigs, { key: `instrumentSelectBy` })
            if (selectBy && selectBy.length > 0) {
                return selectBy[0].value
            }
            return null
        },
        filterScopeInfo() {
            let that = this
            let filterScope = _.filter(that.userConfigs, { key: `instrumentFilterScope` })
            if (filterScope && filterScope.length > 0) {
                return filterScope[0].value.trim()
            }
            return [2]
        },
        worker() {
            if (this.isWorkerByDuty == `0`) {
                return this[`sysuser/workers_by_duty`]
            } else if (this.isWorkerByDuty == `1`) {
                return this[`sysuser/workers_by_dutyNew`]
            }
        },
        workoption() {
            return q => {
                let works = this.isWorkerByDuty == `0` ? this.worker[`护士`] || [] : this.worker[`巡回护士`] || []
                if (q && q.keyword) {
                    return works.filter(d => {
                        return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                    })
                } else {
                    return works
                }
            }
        },
        columnWidth() {
            if (this.screenWidth > 1024) {
                return 140
            }
            return 110
        },
        appendPackageColumns() {
            if (this.instore_style == `hand` && this.packageWithBarcode == 2) { // 器械清点含扫码入库
                return [
                    {
                        type: `scan`,
                        prop: `internal_code`,
                        label: `条码号`,
                        colspan: 8,
                        placeholder: `请扫码或者手动输入条码号`,
                        autofocus: true,
                        change: function($that, { row }) {
                            if (!$that.emitNewScan) {
                                $that.emitNewScan = _.debounce(function() {
                                    $that.$emit(`addnew-scan`, row)
                                }, 1000)
                            }
                            $that.emitNewScan()
                        },
                        config: {
                            autofocus: true
                        }
                    }
                ].concat(this.packageListColumn)
            } else if ((this.selectType && this.selectType == 1) || (!this.selectType && this.instore_style == `hand` && this.packageWithBarcode == 0)) { // 参数配置为下拉框
                return [
                    {
                        type: `groupselect`,
                        prop: `internal_code`,
                        label: `器械包`,
                        colspan: 10,
                        options: this.internalcodes,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        default: ``
                    },
                    {
                        type: `buttongroup`,
                        prop: `instore`,
                        label: ``,
                        colspan: 8,
                        readonly: false,
                        options: [
                            {
                                label: `添加`,
                                type: `primary`,
                                emit: `appendPackageConfirm`,
                                permission: `default`
                            }
                        ]
                    }
                ].concat(this.packageListColumn)
            } else {
                return [
                    {
                        type: `scan`,
                        prop: `internal_code`,
                        label: `条码号`,
                        colspan: 8,
                        placeholder: `请扫码或者手动输入条码号`,
                        autofocus: true,
                        change: function($that, { row }) {
                            if (!$that.emitNewScan) {
                                $that.emitNewScan = _.debounce(function() {
                                    $that.$emit(`new-scan`, row)
                                }, 1000)
                            }
                            $that.emitNewScan()
                        },
                        config: {
                            autofocus: true
                        }
                    }
                ].concat(this.packageListColumn)
            }
        },
        packageListColumn() {
            return [
                {
                    type: `table2`,
                    prop: `packages`,
                    label: { content: `器械包列表`, position: `top` },
                    options: this.tablePackageColumns,
                    default: [],
                    colspan: 17
                },
                {
                    type: `table2`,
                    prop: `instruments`,
                    label: { content: `器械包详情`, position: `top` },
                    options: [
                        {
                            type: `string`,
                            prop: `name`,
                            label: `器械名称`,
                            isListable: true
                        },
                        {
                            type: `string`,
                            prop: `quantity`,
                            label: this.packageIn.package_detail_quantity_label,
                            isListable: true
                        }
                    ],
                    default: [],
                    colspan: 7
                }
            ]
        },
        tablePackageColumns() {
            return [
                {
                    type: `string`,
                    prop: `dic_instrument_package_id`,
                    label: ` `,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `package_name`,
                    label: `名称`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `internal_code`,
                    label: `条码号`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `valid_date`,
                    label: `有效期`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain`,
                            label: `移除`,
                            type: `danger`,
                            emit: `remove`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        itemd() {
            return _.tail(this.tableData).map(d => {
                return {
                    value: `${d.group_id || 0}_${d.item_id}`,
                    label: d.item_name,
                    group: d.group_name,
                    item_id: d.item_id,
                    group_id: d.group_id
                }
            })
        },
        damagedViewColumns() {
            return [
                {
                    type: `groupselect`,
                    prop: `itemid`,
                    label: `物品`,
                    options: this.itemd,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `select`,
                    prop: `enum_count_stage`,
                    label: `节点`,
                    options: this.columnSetting,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `number`,
                    prop: `amount`,
                    label: `数量`,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: 1
                },
                {
                    type: `select`,
                    prop: `enum_stuff_destination`,
                    label: `去向`,
                    options: this.sys_enums.Enum_StuffDestination,
                    colspan: 4,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    default: 1
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    colspan: 4
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: ``,
                    options: [
                        {
                            // class:"is-plain",
                            label: `添加`,
                            type: `primary`,
                            emit: `appendDamaged`,
                            permission: `default`
                        }
                    ],
                    colspan: 4
                },
                {
                    type: `table2`,
                    prop: `damaged`,
                    label: { content: `耗损记录`, position: `top` },
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `编号`
                        },
                        {
                            type: `string`,
                            prop: `name`,
                            label: `名称`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `biz_count_stage_id`,
                            label: `节点`,
                            isListable: true,
                            options: this.columnSetting
                        },
                        {
                            type: `string`,
                            prop: `amount`,
                            label: `数量`,
                            isListable: true
                        },
                        {
                            type: `select`,
                            prop: `stuff_destination`,
                            label: `去向`,
                            isListable: true,
                            options: this.sys_enums.Enum_StuffDestination
                        },
                        {
                            type: `string`,
                            prop: `remark`,
                            label: `备注`,
                            isListable: true
                        },
                        {
                            type: `buttongroup`,
                            prop: `oper`,
                            label: `操作`,
                            width: `100`,
                            readonly: false,
                            isListable: true,
                            options: [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    type: `danger`,
                                    emit: `deleteDamaged`,
                                    permission: `default`,
                                    isListable: true
                                }
                            ]
                        }
                    ],
                    colspan: 24
                }
            ]
        }
    },
    methods: {
        loadInternalcodes() {
            if (!this.surgeryId) return
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Nursing/CountingContent/Search?wardId=${this.active_ward.origion}&surgeryId=${this.surgeryId}&filterScope=${this.filterScopeInfo}`)
                req.then(data => {
                    this.internalcodes = data
                }).catch(e => {
                    this.internalcodes = []
                })
            })
        },
        loadPackageWithBarcode() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=PackageWithBarcode`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.packageWithBarcode = parseInt(data.value)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        catKeyVal(item) {
            return `${item.group_id}_${item.item_id}`
        },
        setTableheight() {
            let el = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`)
            let elFixed = this.$refs[`cus-table`].$el.querySelector(`.el-table__fixed-body-wrapper`)
            let elHeader = this.$refs[`cus-table`].$el.querySelector(`.el-table__header-wrapper`)
            el.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`
            elFixed && elFixed.style && (elFixed.style.height = `${this.tableHeight - elHeader.offsetHeight - 5}px`)
        },
        loadColumnSetting() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/CountingFlow/GetFlow?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    let r = _.find(data, { id: this.id })
                    this.equipments_bak = this.equipments = r.dic_worker_inst || []
                    this.circuits_bak = this.circuits = r.dic_worker_circuit || []
                    this.columnSetting = _.map(_.orderBy(r.count_stage, `display_order`), (d, index) => {
                        d.prop = `c${d.dic_event_id}`
                        d.label = d.stage_name
                        d.value = d.id
                        if (index > 0 && this.$moment(d.modify_date).format(`YYYYMMDD`) == `19010101`) {
                            d.locked = true
                        } else {
                            d.locked = false
                        }
                        return d
                    })
                    resolve()
                }).catch(e => reject(e))
            })
        },
        loadCountings() {
            let req = this.myaxios.post(
                `/api/Nursing/CountingContent/${this.package_style == `separated` ? `GetStagesDataSeparated` : `GetStagesData`}`,
                _.map(this.columnSetting, d => d.id)
            )
            let req2 = this.loadDamaged()
            this.myaxios.all(req, req2).then(([data, damaged]) => {
                let modifyTime = { item_name: `时间`, item_id: TIME_ROW_ID, item_type: `时间` }
                _.forEach(this.columnSetting, (c, index) => {
                    modifyTime[c.prop] = this.$moment(c.modify_date).format(`YYYY/MM/DD HH:mm:ss`)
                })
                let instrumentsCountByGroup = _.reduce(
                    _.groupBy(data, `use_package_id`),
                    function(result, value, key) {
                        result[key] = {
                            length: value.length,
                            first: 0
                        }
                        return result
                    },
                    {}
                )
                let ct = _.map(data, (d, index) => {
                    if (instrumentsCountByGroup[d.use_package_id].first == 0) {
                        instrumentsCountByGroup[d.use_package_id].first = index + 1
                    }
                    d.group_id = d.use_package_id
                    d.group_name = `${d.use_package_id} ${d.use_package_name}`
                    d.item_id = d.instrument_id
                    d.item_name = d.instrument_name
                    _.forEach(this.columnSetting, (c, index) => {
                        d[c.prop] = d.amount[index]
                        d[`un_eq_${c.prop}`] = 0
                        if (c.calculate_relation) {
                            _.forEach(c.calculate_relation.split(`,`), i => {
                                d[`un_eq_${c.prop}`] += (d[`c${i}`] && d[`c${i}`] == -1 ? 0 : d[`c${i}`]) || 0
                            })
                        }
                        let dmgs = _.filter(damaged, { dic_instrument_id: d.instrument_id, biz_count_stage_id: c.id })
                        if (this.package_style == `separated`) {
                            dmgs = _.filter(dmgs, { biz_use_package_id: d.group_id })
                        }

                        if (dmgs.length > 0) {
                            let dmg = {
                                amount: _.sumBy(dmgs, d => d.amount),
                                stuff_destination: _.map(dmgs, d => `${d.stuff_destination}(${d.amount})`).toString(),
                                remark: _.map(dmgs, d => (d.remark == null ? `` : `${d.stuff_destination}:${d.remark}`)).toString()
                            }
                            d[`damaged_${c.prop}`] = dmg
                        }
                        d[`need_check_${c.prop}`] = c.need_check
                    })
                    return d
                })
                if (ct.length > 0) {
                    ct.splice(0, 0, modifyTime)
                }
                if (this.showCountStageTime == `0`) {
                    ct = ct.filter(d => { return d.item_name != `时间` })
                }
                this.instruments_count_by_group = instrumentsCountByGroup
                this.instrument_count = ct.length
                this.tableData_bak = _.cloneDeep(ct)
                this.tableData = ct
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (this.package_style.toLowerCase() == `combin`) return [1, 1]
            if (this.showCountStageTime == `0`) {
                if (columnIndex === 0) {
                    if (this.instruments_count_by_group[row.group_id].first - 1 == rowIndex) {
                        return [this.instruments_count_by_group[row.group_id].length, 1]
                    } else {
                        return [0, 0]
                    }
                }
            } else {
                if (column.property == `group_name` && rowIndex > 0) {
                    if (this.instruments_count_by_group[row.group_id].first == rowIndex) {
                        return [this.instruments_count_by_group[row.group_id].length, 1]
                    } else {
                        return [0, 0]
                    }
                } else {
                    return [1, 1]
                }
            }
        },
        loadAppendPackageView(stage) {
            this.stage = stage
            let req = this.myaxios.get(`/api/Nursing/CountingContent/GetUsedPackage?stageId=${this.stage}`)
            req.then(usedpackage => {
                // let  r =_.differenceWith(enum_package,usedpackage,function(arrVal, othVal){return arrVal.value == othVal.dic_instrument_package_id})
                // this.packageIn.enum_package = _.map(usedpackage,d=>{return {value:d.dic_instrument_package_id,label:d.package_name}}).concat(r)
                this.packageIn.packages = usedpackage || []
                this.packageIn.instruments = []
                // if(usedpackage.length>0){
                //   that.rowClick({row:usedpackage[0]})
                // }
                this.packageIn.dialogFormVisible = true
            }).catch(e => {
                console.log(e)
            })
        },
        loadUsedPackage() {
            let req = this.myaxios.get(`/api/Nursing/Counting/GetUsedPackage?surgeryId=${this.surgeryId}&stage=${this.stage}`)
            req.then(data => {
                this.packageIn.packages = data || []
            }).catch(e => {
                console.log(e)
            })
        },
        appendPackageConfirm() {
            this.$refs[`form-appendPackage`].confirm()
        },
        appendPackage(row) {
            let that = this
            let used = _.filter(that.packageIn.packages, function(i) {
                return i.internal_code.toUpperCase() == row.internal_code.trim().toUpperCase()
            })
            if (used && used[0]) {
                return
            }
            let req = that.myaxios.post(
                `/api/Nursing/CountingContent/${this.package_style == `separated` ? `AddPackageSeparated` : `AddPackage`}?code=${row.internal_code}&wardId=${this.active_ward.origion}&surgeryId=${
                    this.surgeryId
                }&stageId=${this.stage}`
            )
            let req2
            let cs = _.find(this.columnSetting, { id: this.stage })
            let timeRow = _.find(this.tableData, { item_id: TIME_ROW_ID })
            let now = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            if (!timeRow || timeRow[cs.prop] == `1901/01/01 00:00:00` || this.showCountStageTime == `0`) {
                req2 = this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${this.stage}&dateTime=${now}`)
            } else {
                req2 = Promise.resolve(``)
            }
            this.myaxios
                .all(req, req2)
                .then(([data, t]) => {
                    that.packageIn.packages.push(data)
                    that.rowClick({ row: data })
                    this.loadColumnSetting().then(() => {
                        that.loadInternalcodes()
                        this.loadCountings()
                    })
                    that.$refs[`form-appendPackage`].clearField()
                    // that.loadCountings()
                })
                .catch(e => {
                    console.log(e)
                })
        },
        saveInfo(row, fiv) {
            let that = this
            // 器械包绑定清点流程
            let req = that.myaxios.post(
                `/api/Nursing/CountingContent/${this.package_style == `separated` ? `ScanPackageSeparated` : `ScanPackage`}?code=${row.internal_code.trim()}&surgeryId=${this.surgeryId}&stageId=${
                    this.stage
                }&wardId=${this.active_ward.origion}`
            )
            let req2
            let cs = _.find(that.columnSetting, { id: that.stage })
            let timeRow = _.find(that.tableData, { item_id: TIME_ROW_ID })
            let now = that.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            if (!timeRow || timeRow[cs.prop] == `1901/01/01 00:00:00` || this.showCountStageTime == `0`) {
                req2 = that.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${that.stage}&dateTime=${now}`)
            } else {
                req2 = Promise.resolve(``)
            }
            that.myaxios
                .all(req, req2).then(([data], t) => {
                    if (data && fiv == -1) {
                        that.packageIn.packages.push(data)
                        that.rowClick({ row: data })
                    } else {
                        that.packageIn.packages.splice(fiv, 1)
                        that.packageIn.instruments = []
                    }
                    that.loadColumnSetting().then(() => {
                        that.loadInternalcodes()
                        that.loadCountings()
                    })
                    that.$refs[`form-appendPackage`].$refs.ItemInput[0].scan_val = ``
                }).catch(e => {
                    console.log(e)
                })
        },
        // 器械包扫码清点直接入库
        addAndInStoreByScan(row) {
            let that = this
            let fiv = _.findIndex(that.packageIn.packages, function(i) {
                return i.internal_code.toUpperCase() == row.internal_code.trim().toUpperCase()
            })
            let task = new Promise((resolve, reject) => {
                if (fiv > -1) {
                    this.$confirm(`是否删除?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve()
                        })
                        .catch(e => {
                            reject()
                        })
                } else {
                    resolve()
                }
            })
            task.then(() => {
                // 器械包校验是否存在库中，不存在先新增，存在则不处理直接操作数据绑定
                let req = that.myaxios.put(`/api/Nursing/UsePackage/ScanInstrument?code=${row.internal_code.trim()}&surgeryId=${this.surgeryId}`)
                req.then(data => {
                    that.saveInfo(row, fiv)
                }).catch(e => {
                    console.log(e)
                    that.$message.warning(e)
                    that.$refs[`form-appendPackage`].$refs.ItemInput[0].scan_val = ``
                })
            }).catch(e => {})
        },
        inStoreByScan(row) {
            let that = this
            let fiv = _.findIndex(that.packageIn.packages, function(i) {
                return i.internal_code.toUpperCase() == row.internal_code.trim().toUpperCase()
            })
            let task = new Promise((resolve, reject) => {
                if (fiv > -1) {
                    this.$confirm(`是否删除?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve()
                        })
                        .catch(e => {
                            reject()
                        })
                } else {
                    resolve()
                }
            })
            task.then(() => {
                that.saveInfo(row, fiv)
            }).catch(e => {})
        },
        rowClick({ row }) {
            let that = this
            if (row.dic_instrument_package_id && that.packageIn.activePackage == row.dic_instrument_package_id && this.packageIn.instruments.length > 0) return
            that.packageIn.activePackage = row.dic_instrument_package_id
            let req2 = that.myaxios.get(`/api/AcisSystem/Package/Get/${row.dic_instrument_package_id}`)
            req2.then(instrumentPackage => {
                let sumCount = _.sumBy((instrumentPackage && instrumentPackage.instruments) || [], function(o) {
                    return o.quantity
                })
                that.packageIn.package_detail_quantity_label = `数量(总计：${sumCount}个)`
                that.packageIn.instruments = (instrumentPackage && instrumentPackage.instruments) || []
            }).catch(e => {
                console.log(e)
            })
        },
        ExtraButtonClick(target) {
            if (target.emit == `rowClick`) return
            this[target.emit] && this[target.emit](target)
        },
        ExtraButtonClick2(target) {
            this[target.emit] && this[target.emit](target)
        },
        remove({ index, row }) {
            // 移除一行
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.post(
                        `/api/Nursing/CountingContent/${this.package_style == `separated` ? `RemovePackageSeparated` : `RemovePackage`}?usePackageId=${row.id}&stageId=${this.stage}`
                    )
                    req.then(data => {
                        that.packageIn.packages.splice(index, 1)
                        that.loadInternalcodes()
                        that.$message.success(`移除成功`)
                        if (that.packageIn.packages && that.packageIn.packages.length == 0) {
                            that.packageIn.instruments = []
                        } else {
                            this.rowClick({ row: that.packageIn.packages[0] })
                        }
                        that.loadCountings()
                    }).catch(e => {
                        console.log(e)
                    })
                })
                .catch(e => {})
        },
        AutoComplete(stage) {
            let that = this
            if (
                this.checkColumn != undefined &&
                        this.tableData.length - 1 >
                            _.filter(this.checkboxs, d => {
                                return d
                            }).length &&
                this.tableData[0][`need_check_${this.checkColumn}`]
            ) {
                this.$message.error(`核查项未全部确认，请先勾选确认`)
                return
            }

            // 刷新列
            let cr = _.find(this.columnSetting, { id: stage })
            this.$set(cr, `locked`, false)
            this.checkColumn = cr.prop
            this.tableData = this.tableData.map((d, index) => {
                let r = { ...d }
                r[cr.prop] = 0
                if (index == 0 && (!this.showCountStageTime || this.showCountStageTime == `1`)) {
                    r[cr.prop] = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                } else if (cr.calculate_relation) {
                    _.forEach(cr.calculate_relation.split(`,`), i => {
                        let rnum = parseInt(r[`c${i}`] && r[`c${i}`] == -1 ? 0 : r[`c${i}`])
                        r[cr.prop] += rnum || 0
                    })
                }
                r[`un_eq_${cr.prop}`] = r[cr.prop]
                if (!that.showCountStageTime || that.showCountStageTime == `1`) {
                    r.display_order = index
                } else {
                    r.display_order = index + 1
                }
                r[`need_check_${cr.prop}`] = cr.need_check
                this.RowChange({ index, row: r, prop: cr.prop })
                return r
            })
        },
        RowChange({ index, row, prop }) {
            // 监听更改的行
            let oldr = this.tableData_bak[index]
            let r = { item_id: oldr.item_id, group_id: oldr.group_id, display_order: row.display_order || 0 }
            let i = _.findIndex(this.rowChanges, { item_id: oldr.item_id, group_id: oldr.group_id })
            if ((oldr && oldr[prop]) == row[prop] && this.rowChanges && this.rowChanges[i]) {
                this.$delete(this.rowChanges[i], prop)
                if (Object.getOwnPropertyNames(this.rowChanges[i]).length == 3) {
                    this.rowChanges.splice(i, 1)
                }
            } else {
                r[prop] = row[prop]
                if (i > -1) {
                    this.rowChanges[i][prop] = row[prop]
                } else {
                    this.rowChanges.push(r)
                }
            }
        },
        clearChanges() {
            this.loadColumnSetting().then(() => {
                this.loadCountings()
            })
            this.finished = true
            this.rowChanges = []
            this.checkColumn = undefined
            this.equipments = this.equipments_bak
            this.circuits = this.circuits_bak
        },
        SaveChanges() {
            //  保存用户更改，成功刷新数据，失败不刷新
            let that = this
            if (that.finished) {
                let step = new Promise((resolve, reject) => {
                    if (
                        this.checkColumn != undefined &&
                        this.tableData.length - 1 >
                            _.filter(this.checkboxs, d => {
                                return d
                            }).length
                    ) {
                        if (this.tableData[0][`need_check_${this.checkColumn}`]) {
                            this.$message.error(`核查数据未全部确认，请勾选确认`)
                            reject()
                        } else {
                            this.$confirm(`未全部确认, 是否继续?`, `提示`, {
                                confirmButtonText: `确定`,
                                cancelButtonText: `取消`,
                                type: `warning`,
                                closeOnClickModal: false
                            })
                                .then(() => {
                                    resolve()
                                })
                                .catch(e => {
                                    reject()
                                })
                        }
                    } else {
                        resolve()
                    }
                })
                step.then(() => {
                    that.finished = false
                    let timeRow = _.find(that.tableData, { item_id: TIME_ROW_ID })
                    let now = that.$moment().format(`YYYY/MM/DD HH:mm:ss`)
                    let reqs = []
                    // 验证时间
                    let prevT
                    let msg
                    let cs = _.filter(that.columnSetting, d => !d.locked)
                    _.forEach(cs, c => {
                        if (!c.locked) {
                            if (timeRow && timeRow[c.prop]) {
                                if (prevT && !that.$moment(timeRow[c.prop]).isAfter(timeRow[prevT.prop]) && timeRow[c.prop] != timeRow[prevT.prop]) {
                                    msg = `${prevT.stage_name}  的时间不允许超过 ${c.stage_name}`
                                }
                                prevT = c
                                reqs.push(this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${c.id}&dateTime=${timeRow[c.prop]}`))
                            } else if (that.showCountStageTime == `0`) {
                                reqs.push(this.myaxios.post(`/api/Nursing/CountingFlow/UpdateStageTime?stageId=${c.id}&dateTime=${now}`))
                            }
                        }
                    })
                    let models = _.reduce(
                        _.filter(that.rowChanges, row => {
                            return row.item_id != TIME_ROW_ID
                        }),
                        function(result, row, index) {
                            _.forEach(cs, c => {
                                if (row[c.prop] != undefined) {
                                    result.push({
                                        stage_id: c.id,
                                        dic_instrument_id: row.item_id,
                                        amount: row[c.prop],
                                        biz_use_package_id: row.group_id,
                                        display_order: row.display_order
                                    })
                                }
                            })
                            return result
                        },
                        []
                    )
                    if (msg) {
                        that.$message.warning(msg)
                        that.finished = true
                        return
                    }
                    reqs.push(this.myaxios.post(`/api/Nursing/CountingContent/SaveData`, models))
                    reqs.push(
                        this.myaxios.put(`/api/Nursing/CountingFlow/EditFlow`, {
                            id: this.id,
                            dic_worker_inst_id: this.equipments.map(c => c.value),
                            dic_worker_circuit_id: this.circuits.map(c => c.value)
                        })
                    )
                    this.myaxios
                        .all(...reqs)
                        .then(() => {
                            that.finished = true
                            that.equipments_bak = [...that.equipments.map(c => c.value)]
                            that.circuits_bak = [...that.circuits.map(c => c.value)]
                            that.rowChanges = []
                            that.checkboxs = []
                            this.loadColumnSetting().then(() => {
                                this.loadCountings()
                            })
                            this.checkColumn = undefined
                        })
                        .catch(e => {
                            that.finished = true
                        })
                })
            }
        },
        loadDamaged() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/DamagedInstrument/Get?flowId=${this.id}`)
                req.then(data => {
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                    resolve([])
                })
            })
        },
        loadDamagedView() {
            this.loadDamaged().then(data => {
                this.damagedView.damaged = data
                this.damagedView.dialogFormVisible = true
            })
        },
        appendDamaged({ formdata }) {
            let item = _.find(this.itemd, { value: formdata.itemid })
            let req = this.myaxios.post(`/api/Nursing/DamagedInstrument/Post`, {
                biz_count_instrument_id: this.id,
                amount: formdata.amount,
                enum_stuff_destination: formdata.enum_stuff_destination,
                remark: formdata.remark,
                biz_use_package_id: item.group_id,
                dic_instrument_id: item.item_id,
                name: item.label,
                biz_count_stage_id: formdata.enum_count_stage
            })
            req.then(data => {
                this.loadDamagedView()
                this.loadCountings()
            }).catch(e => {
                console.log(e)
            })
        },
        deleteDamaged({ row, index }) {
            let that = this
            let req = this.myaxios.delete(`/api/Nursing/DamagedInstrument/Delete/${row.id}`)
            req.then(data => {
                that.damagedView.damaged.splice(index, 1)
                this.loadCountings()
                that.$message.success(`删除成功`)
            }).catch(e => {
                console.log(e)
            })
        },
        setActiveRow(args) {
            let _this = this
            let rowIndex = args[0]
            let cellIndex = args[1]
            let direction = args[2]
            _this.$nextTick(() => {
                let activeRow = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                if (activeRow && activeRow.children[cellIndex]) {
                    let activeInput = activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                    let celllenth = activeRow.cells.length
                    let rowlen = activeRow.parentElement.nodeName == `TBODY` && activeRow.parentElement.children.length // 行数
                    let whileCount = 0
                    while (!activeInput && whileCount <= rowlen) {
                        switch (direction) {
                        case `up`:
                            rowIndex = rowIndex - 1
                            if (rowIndex < 0) { rowIndex = rowlen - 1 }
                            break
                        case `down`:
                            rowIndex = rowIndex + 1
                            if (rowIndex === rowlen) { rowIndex = 0 }
                            break
                        case `left`:
                            cellIndex = cellIndex - 1
                            if (cellIndex < 0) { cellIndex = celllenth - 1 }
                            break
                        case `right`:
                            cellIndex = cellIndex + 1
                            if (cellIndex === celllenth) { cellIndex = 0 }
                            break
                        case `enter`:
                            cellIndex = cellIndex + 1
                            if (cellIndex === celllenth) {
                                cellIndex = 0
                                rowIndex += 1
                                if (rowIndex === rowlen) { rowIndex = 0 }
                                activeRow = this.$refs[`cus-table`].$el.querySelector(`.el-table__body-wrapper`).querySelectorAll(`.el-table__row`)[rowIndex]
                            }
                            break
                        }

                        activeInput = activeRow && activeRow.children[cellIndex] && activeRow.children[cellIndex].getElementsByTagName(`input`)[0]
                        whileCount += 1
                    }
                    activeInput && activeInput.focus()
                    activeInput && activeInput.select()
                }
            })
        }
    },
    watch: {
        userConfigs: function(newUrl, oldUrl) {
            this.loadInternalcodes()
            console.log(this.selectType)
        }
        // $route: function(newUrl, oldUrl) {
        //   this.surgeryId=newUrl.query.surgery_id
        //   this.loadColumnSetting().then(()=>{
        //     this.loadCountings()
        //   }).catch(()=>{})
        //   this.rowChanges=[]
        // },
        // mode: function(newval, oldval) {
        //   if(oldval!==undefined&&newval!==undefined){
        //     this.$confirm('切换模式后当前模式下数据会被清空, 是否继续?', '提示', {
        //       confirmButtonText: '确定',
        //       cancelButtonText: '取消',
        //       type: 'danger',
        //       closeOnClickModal:false
        //     }).then(() => {
        //       let req1 =this.myaxios.delete(`/api/Nursing/Counting/ClearCounting?surgeryId=${this.surgeryId}`)
        //       req1.then(()=>{
        //         let newcolumnsetting =_.find(this.modes,{value:newval}).columns
        //         let req4 = this.myaxios.post(`/api/Nursing/Counting/SubmitWorkflow?surgeryId=${this.surgeryId}&workflow=${newval}&columnCount=${newcolumnsetting.length}`)
        //         req4.then(data=>{
        //           this.loadCountings()
        //           this.columnSetting = newcolumnsetting
        //         })
        //       })
        //     }).catch(()=>{
        //       if(this.reload){
        //         this.reload()
        //       }
        //     })
        //   }
        // },
    }
}
</script>
<style scoped>
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
</style>
<style lang="less">
.un-eq input {
    color: red !important;
}
.inventory-datetime {
    &.el-input--suffix .el-input__inner {
        padding-right: 5px !important;
    }
    &.el-input--prefix .el-input__inner {
        padding-left: 5px !important;
    }
    .el-input__suffix {
        display: none;
    }
    .el-input__prefix {
        display: none;
    }
    input {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Inventory/ItemInstrument.vue